<template lang="pug">
  div
    div.mt-20
      p.margin-medium-top.label {{isEstadoMA ? 'Boleto' : 'DAE'}}
      app-display(label="Tipo:", :content="tipoPagamento()")
      el-row(
        type="flex",
        justify="left",
        align="bottom"
      )
        app-display.mr-20(label="Valor principal:", v-if="!isParcelado()", :content="formatValorPrincipalAVista()")
        app-display.mr-20(label="Valor do desconto:", v-if="!isParcelado()", :content="formatValorDesconto()")
        app-display.mr-20(label="Valor líquido:", v-if="!isParcelado()", :content="formatValorTotalAVista()")
        app-display.mr-20(label="Valor principal:", v-if="isParcelado()", :content="formatValorPrincipalParcelado()")
        app-display.mr-20(label="Valor do juros:", v-if="isParcelado()", :content="formatValorJuros()")
        app-display.mr-20(label="Valor total:", v-if="isParcelado()", :content="formatValorTotal()")

      .divider.mt-20
      el-row
        el-table(
          stripe
          :data='parcelas',
        )
          el-table-column(type='expand')
            template(slot-scope='props')
              div(v-if="props.row.boletos.length > 0")
                div(v-for="(boleto, index) in props.row.boletos")
                  el-row(
                    type="flex",
                    justify="space-between",
                    align="bottom"
                  )
                    p.label {{props.row.boletos.length - index + 'ª via'}}

                    el-tooltip.item(
                      effect='dark',
                      :content="'Baixar DAE'",
                      placement="left"
                    )
                      el-button.btn(
                        type="text",
                        @click="downloadBoleto(boleto)",
                        size="mini",
                      )
                        span
                          font-awesome-icon.icon(icon="file-pdf" size="2x")

                  el-row.divider

                  app-display(label="Valor Total:", :content="formatValor(boleto.valorPrincipal)")
                  app-display(label="Situação:", :content="getSituacaoVia(boleto.situacao)")
                  app-display(label="Data de emissão:", :content="boleto.dataCalculo")
                  app-display(label="Vencimento:", :content="boleto.dataVencimento")
              div(v-else)
                el-row(
                  type="flex",
                  justify="center",
                  align="bottom"
                )
                  span {{ 'Parcela não emitida' }}

          el-table-column(
            label='Parcela'
            :formatter="formatLabelParcelas"
          )

          el-table-column(
            label='Valor',
            prop="valorPrincial"
            :formatter="formatMoneyProp"
          )

          el-table-column(
            label='Status'
            prop="situacao"
            :formatter="getSituacaoBoleto"
          )

          el-table-column(
            label='Data de vencimento'
            prop="boletos"
            :formatter="formatDataVencimentoProp"
          )

          el-table-column(
            label='Data de Emissão'
            prop="boletos"
            :formatter="formatDataEmissaoProp"
          )

          el-table-column(
            :label="acoesDropdown.titulo",
            :prop="acoesDropdown.propriedade",
            align="center",
            header-align="center",
            width="150"
          )
            template(slot-scope="scope", v-if="scope.row.emitido")
              el-dropdown(trigger="click", size="small")
                el-button(type="primary", size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot="dropdown")
                  el-dropdown-item
                    div(
                      v-if="scope.row.isVencido"
                      @click="reemitir(scope.row.id)"
                    )
                      i.fa(
                        :class="'fa-file-invoice-dollar'"
                      )
                      | &nbsp Reemitir boleto
                    .disabled-content(v-else)
                      i.fa(
                        :class="'fa-file-invoice-dollar'"
                      )
                      | &nbsp Reemitir boleto
                  el-dropdown-item
                    div(
                      v-if="!scope.row.isPaga"
                      @click="editar(scope.row)"
                    )
                      i.fa(
                        :class="'fa-edit'"
                      )
                      | &nbsp Editar boleto
                    .disabled-content(v-else)
                      i.fa(
                        :class="'fa-edit'"
                      )
                      | &nbsp Editar boleto

</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppDisplay,
    AppDivider
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      acoesDropdown: {
        id: 0, titulo: 'Ações', propriedade: 'tipo', //eslint-disable-line
        acoes: [
          {id: 1, nome: 'Reemitir boleto', icone: 'fa-file-invoice-dollar', codigo: 'EMITIR_DAE', ordem: 1, show: this.showEmitirDae},
          {id: 2, nome: 'Editar boleto', icone: 'fa-edit', codigo: 'EDITAR_DAE', ordem: 1, show: this.showEditarDae}
        ]
      }
    }
  },

  props: {
    parcelas: {
      type: Array
    },
    isVoltar: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    calculoValorTotal () {
      let valor = 0
      this.parcelas.forEach(boleto => {
        valor += boleto.valor
      })
      return valor
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    }
  },

  methods: {
    ...mapActions({
      getBoletosByProcesso: 'dae/getBoletosByProcesso',
      downloadDae: 'dae/downloadDae',
      reemitirDae: 'dae/reemitirDae'
    }),
    reemitir (id) {
      this.$emit('reemitirDae', {
        id
      })
    },

    editar (boleto) {
      let boletoEditar = boleto.boletos.filter(b => b.situacao !== 'CANCELADO' && b.situacao !== 'QUITADO')
      if (this.isParcelado()) {
        this.$emit('editarDae', {
          id: boleto.id,
          valorPrincipal: boletoEditar[0].valorPrincipal,
          isParcelado: boletoEditar[0].receita.isParcelado
        })
      } else {
        this.$emit('editarDae', {
          id: boleto.id,
          valorPrincipal: boletoEditar[0].valorPrincipal + this.parcelas[0]?.desconto,
          desconto: this.parcelas[0]?.desconto
        })
      }
    },

    isParcelado () {
      return this.parcelas[0].boletos[0].receita.isParcelado
    },

    tipoPagamento () {
      return this.isParcelado() ? 'À Prazo' : 'À vista'
    },

    formatValor (valor) {
      return valor ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },

    formatValorTotal () {
      return this.formatValor(this.calculoValorTotal)
    },

    formatValorTotalAVista () {
      return this.formatValor(this.calculoValorTotal - this.parcelas[0]?.desconto)
    },

    formatValorDesconto () {
      return this.formatValor(this.parcelas[0]?.desconto)
    },

    formatValorPrincipalAVista () {
      return this.formatValor(this.calculoValorTotal)
    },

    formatValorJuros () {
      return this.formatValor(this.parcelas[0]?.juros)
    },

    formatValorPrincipalParcelado () {
      return this.formatValor(this.calculoValorTotal - this.parcelas[0]?.juros)
    },

    formatLabelParcelas (prop) {
      if (this.isParcelado()) return prop.numeroParcela === 1 ? 'Entrada' : `${prop.numeroParcela}ª parcela`
      return 'Parcela única'
    },

    async downloadBoleto (boleto) {
      await this.downloadDae(boleto.receita.id)
    },

    reemitirBoleto (id) {
      this.confirmBox(this.isEstadoMA ? this.$messages.CONFIRMAR_BOLETO.replace('DAE', 'Boleto') : this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        () => {
          this.reemitirDae(id).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
              this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
            this.$router.push({
              name: 'DAE'
            })
          }).catch((error) => {
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              error.message
            )
          })
        },
        () => {})
    },
    formatMoneyProp (prop) {
      return this.isParcelado() ? this.formatValor(prop.valor) : this.formatValorTotalAVista()
    },

    getSituacaoBoleto (prop) {
      if (prop.emitido && prop.isPaga) {
        return 'Pago'
      } else if (prop.emitido && !prop.isVencido) {
        return 'Aguardando pagamento'
      } else if (prop.emitido && prop.isVencido) {
        return 'Vencido'
      } else if (!prop.emitido) {
        return 'Aguardando emissão do boleto'
      } else {
        return 'Cancelado'
      }
    },

    getSituacaoVia (status) {
      if (status === 'VENCIDO') {
        return 'Vencido'
      } else if (status === 'AGUARDANDO_PAGAMENTO') {
        return 'Aguardando pagamento'
      } else if (status === 'QUITADO') {
        return 'Pago'
      } else {
        return 'Cancelado'
      }
    },

    formatData (data) {
      return data ? moment(data).format('DD/MM/YYYY') : '-'
    },

    formatDataVencimentoProp (props) {
      return props.emitido ? props.boletos[0].dataVencimento : '-'
    },

    formatDataEmissaoProp (props) {
      return props.emitido ? props.boletos[0].dataCalculo : '-'
    },

    voltar () {
      this.$router.push({
        name: 'caixa-entrada-cof'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}

.divider {
  border: 1px solid #dfe4ed;
  margin-bottom: 10px;
}

.btn {
  padding: 5px;
  color: #33b281;
}

.mt-20 {
  margin-top: 20px;
}

.mr-20 {
  margin-right: 20px !important;
}

.disabled-content {
  opacity: 0.4;
  cursor: default;
}

>>> .el-table__row {
  &:last-child {
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppPagamentoMa.vue